/** The "golden family": Golden Number Breakout and its experimental copies.
 * These strategies share the golden-number/ladder chart plumbing (per-day
 * golden step-line, ladder levels, backend golden-numbers endpoints). Add a
 * new copy's strategy key here to light all of that up for it. */
export const GOLDEN_FAMILY_KEYS = [
  "golden_number_breakout",
  "daily_htp_ladders",
  "htp_ladders_3m",
] as const;

export function isGoldenFamily(key: string | null | undefined): boolean {
  return !!key && (GOLDEN_FAMILY_KEYS as readonly string[]).includes(key);
}
